var exports = {
  "MY": "OAuthAuthorizePage.module__page___clg3di",
  "Un": "OAuthAuthorizePage.module__errorContainer___clg3di",
  "ow": "OAuthAuthorizePage.module__errorContent___clg3di",
  "JU": "OAuthAuthorizePage.module__errorTitle___clg3di",
  "kc": "OAuthAuthorizePage.module__errorText___clg3di",
  "d1": "OAuthAuthorizePage.module__heroCard___clg3di",
  "iC": "OAuthAuthorizePage.module__heroCopy___clg3di",
  "ZY": "OAuthAuthorizePage.module__heroTitle___clg3di",
  "fd": "OAuthAuthorizePage.module__heroDescription___clg3di",
  "$2": "OAuthAuthorizePage.module__cardGrid___clg3di",
  "Ql": "OAuthAuthorizePage.module__accountList___clg3di",
  "ts": "OAuthAuthorizePage.module__sectionDivider___clg3di",
  "nd": "OAuthAuthorizePage.module__panel___clg3di",
  "bV": "OAuthAuthorizePage.module__sectionHeader___clg3di",
  "Gf": "OAuthAuthorizePage.module__sectionTitle___clg3di",
  "yV": "OAuthAuthorizePage.module__sectionDescription___clg3di",
  "s0": "OAuthAuthorizePage.module__inlineStatus___clg3di",
  "Jb": "OAuthAuthorizePage.module__scopeList___clg3di",
  "_9": "OAuthAuthorizePage.module__permissionScrollContainer___clg3di",
  "C6": "OAuthAuthorizePage.module__permissionScroller___clg3di",
  "Mg": "OAuthAuthorizePage.module__permissionList___clg3di",
  "ce": "OAuthAuthorizePage.module__permissionRow___clg3di",
  "Ck": "OAuthAuthorizePage.module__permissionLabel___clg3di",
  "rJ": "OAuthAuthorizePage.module__scopeRow___clg3di",
  "BB": "OAuthAuthorizePage.module__scopeHeading___clg3di",
  "OK": "OAuthAuthorizePage.module__scopeName___clg3di",
  "RJ": "OAuthAuthorizePage.module__scopeDescription___clg3di",
  "Pp": "OAuthAuthorizePage.module__scopeChip___clg3di",
  "p$": "OAuthAuthorizePage.module__emptyState___clg3di",
  "uL": "OAuthAuthorizePage.module__caution___clg3di",
  "iB": "OAuthAuthorizePage.module__dangerNotice___clg3di",
  "mW": "OAuthAuthorizePage.module__successScreen___clg3di",
  "n7": "OAuthAuthorizePage.module__successIconCircle___clg3di",
  "FU": "OAuthAuthorizePage.module__successIcon___clg3di",
  "QK": "OAuthAuthorizePage.module__successTitle___clg3di",
  "s3": "OAuthAuthorizePage.module__successSubtitle___clg3di",
  "cs": "OAuthAuthorizePage.module__successAction___clg3di",
  "By": "OAuthAuthorizePage.module__guildOption___clg3di",
  "rZ": "OAuthAuthorizePage.module__guildValue___clg3di",
  "XN": "OAuthAuthorizePage.module__guildAvatar___clg3di",
  "oM": "OAuthAuthorizePage.module__guildAvatarPlaceholder___clg3di",
  "p2": "OAuthAuthorizePage.module__guildOptionLabel___clg3di",
  "RG": "OAuthAuthorizePage.module__guildOptionDisabled___clg3di",
  "p4": "OAuthAuthorizePage.module__guildOptionNotice___clg3di",
  "A2": "OAuthAuthorizePage.module__actionSection___clg3di",
  "PJ": "OAuthAuthorizePage.module__footerText___clg3di",
  "o1": "OAuthAuthorizePage.module__actions___clg3di",
  "hP": "OAuthAuthorizePage.module__actionButton___clg3di",
};

module.exports = exports;
